// extracted by mini-css-extract-plugin
export default {"infoBox":"SupportStaff_infoBox__fC9rm"};